import React from 'react'; // useEffect, useLocation, useNavigate kaldırıldı
import { ConfigProvider } from 'antd';
import trTR from 'antd/locale/tr_TR'; // Turkish locale for Ant Design
// Router import yolu düzeltildi
import Router from './Route';
// Provider import yolları düzeltildi ve yenileri eklendi
import CustomizerProvider from './_helper/Customizer/CustomizerProvider';
import AnimationThemeProvider from './_helper/AnimationTheme/AnimationThemeProvider';
// Yeni Provider'ları import edelim (Yolların doğru olduğunu varsayıyoruz)
import AnnouncementProvider from './_helper/Announcement/AnnouncementProvider'; // Varsayılan yol
import NotificationProvider from './_helper/Notification/NotificationProvider'; // Varsayılan yol

// Kaldırılan importlar ve yorum satırları temizlendi

// ----------------------------------------------------------------------

function App() {
  // Ortam değişkeni, useEffect, useLocation, useNavigate kaldırıldı

  return (
    // Tüm Provider'ları en dışta sarmalayalım
    <AnnouncementProvider>
      <NotificationProvider>
        <CustomizerProvider>
          <AnimationThemeProvider>
            <ConfigProvider locale={trTR}>
              <Router />
            </ConfigProvider>
          </AnimationThemeProvider>
        </CustomizerProvider>
      </NotificationProvider>
    </AnnouncementProvider>
  );
}

export default App;
